export enum ReportTabType {
  PUBLIC = "public",
  MY = "my",
}
